import { Routes, RouterModule } from '@angular/router';
import { ConsultaMarkListComponent } from './consulta-mark-list.component';

export const routes: Routes = [
  {
    path: '',
    component: ConsultaMarkListComponent,
  },
];

export const routing = RouterModule.forChild(routes);
